import { BaseError } from '@dynamic-labs-sdk/client';

export class SegwitOutputScriptError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'segwit_output_script_error',
      docsUrl: null,
      name: 'SegwitOutputScriptError',
      shortMessage: 'Failed to create segwit output script',
    });
  }
}
